module.exports = __webpack_public_path__ + "img/3SystemInformation.ac66312e.png";